export class CustomDateFormats {
  public static readonly MediumNoSeconds = 'MMM d, yyyy h:mm aa';
  public static readonly MediumNoTime = 'MMM d, yyyy';
}